import {
  FILE_DISPLAY_NAME_MAX,
  FOLDER_DISPLAY_NAME_MAX,
} from "../constants/limits";
import { getFileExtension, isAllowedExtension } from "../constants/mime-map";
import { getStorageErrorMessage } from "./storageErrors";

export type ValidateDisplayNameResult =
  | { ok: true; displayName: string }
  | { ok: false; message: string };

export function validateFolderDisplayName(
  displayName: string
): ValidateDisplayNameResult {
  const trimmed = displayName.trim();

  if (!trimmed || trimmed.length > FOLDER_DISPLAY_NAME_MAX) {
    return {
      ok: false,
      message: `O nome deve ter entre 1 e ${FOLDER_DISPLAY_NAME_MAX} caracteres.`,
    };
  }

  return { ok: true, displayName: trimmed };
}

export function getFileBaseName(displayName: string, extension: string): string {
  const normalizedExtension = extension.toLowerCase();
  const suffix = `.${normalizedExtension}`;

  if (displayName.toLowerCase().endsWith(suffix)) {
    return displayName.slice(0, -suffix.length);
  }

  const lastDot = displayName.lastIndexOf(".");
  if (lastDot > 0) {
    return displayName.slice(0, lastDot);
  }

  return displayName;
}

export function validateFileBaseName(
  baseName: string,
  extension: string
): ValidateDisplayNameResult {
  const trimmedBase = baseName.trim();

  if (!trimmedBase) {
    return {
      ok: false,
      message: "Informe um nome para o arquivo.",
    };
  }

  const normalizedExtension = extension.toLowerCase();

  if (!isAllowedExtension(normalizedExtension)) {
    return {
      ok: false,
      message: getStorageErrorMessage("INVALID_EXTENSION"),
    };
  }

  const displayName = `${trimmedBase}.${normalizedExtension}`;

  if (displayName.length > FILE_DISPLAY_NAME_MAX) {
    return {
      ok: false,
      message: "O nome deve ter entre 1 e 255 caracteres.",
    };
  }

  return { ok: true, displayName };
}

export function validateFileDisplayName(
  displayName: string,
  originalExtension: string
): ValidateDisplayNameResult {
  const trimmed = displayName.trim();

  if (!trimmed || trimmed.length > FILE_DISPLAY_NAME_MAX) {
    return {
      ok: false,
      message: "O nome deve ter entre 1 e 255 caracteres.",
    };
  }

  const extension = getFileExtension(trimmed);
  const requiredExtension = originalExtension.toLowerCase();

  if (!extension || extension !== requiredExtension) {
    return {
      ok: false,
      message: "A extensão do arquivo não pode ser alterada.",
    };
  }

  const baseName = trimmed.slice(0, trimmed.lastIndexOf("."));
  if (!baseName.trim()) {
    return {
      ok: false,
      message: "Informe um nome para o arquivo.",
    };
  }

  if (!isAllowedExtension(extension)) {
    return {
      ok: false,
      message: getStorageErrorMessage("INVALID_EXTENSION"),
    };
  }

  return { ok: true, displayName: trimmed };
}
